import { Pipe, PipeTransform } from '@angular/core';

import { RangeResponseFilter } from '@shared/filters/entities/fetch-filters.response';

@Pipe({
  name: 'assignObjectFilterValue',
  standalone: false
})
export class AssignObjectFilterValuePipe implements PipeTransform {

  transform(value: unknown): RangeResponseFilter {
    return value as RangeResponseFilter;
  }
}
